import { InspectionResolved } from '../../features/AssetGrid/types/inspection.types';
import { addNamespace } from '../../features/AssetGrid/utils/actions';
import { createAction } from '@reduxjs/toolkit';

export const getInspections = createAction<string>(
	addNamespace('inspection/getInspections'),
);
export const getInspectionsResolved = createAction<InspectionResolved>(
	addNamespace('inspection/getInspections/resolved'),
);
export const getInspectionsRejected = createAction(
	addNamespace('inspection/getInspections/rejected'),
);

export const clearInspections = createAction(
	addNamespace('inspection/clearInspections'),
);
